import _get from 'lodash/get'
import nluApi from '../../api/nlu'

export default {
  namespaced: true,

  state: {
    isTrainingForTest: false,
    phraseIsTesting: false
  },

  actions: {
    async trainTestModel ({ state, rootState, rootGetters, dispatch, commit }) {
      try {
        commit('SET_TRAINING_FOR_TEST', true)
        await nluApi.trainForTest({
          kbId: rootState.knowledgebase.current
        })
        const statusResponse = await dispatch('knowledgebase/statuses/fetchStatus', null, { root: true })

        await Promise.all([
          dispatch('knowledgebase/fetchCategories', null, { root: true }),
          dispatch('knowledgebase/listAllModels', null, { root: true }),
          dispatch('knowledgebase/entities/fetchAllPrebuiltEntities', null, { root: true }),
          dispatch('knowledgebase/entities/fetchAllEntities', null, { root: true }),
          dispatch('knowledgebase/fetchAllApplications', null, { root: true })
        ])
        commit('SET_TRAINING_FOR_TEST', false)

        if (statusResponse.status === 'FAILED') {
          dispatch('knowledgebase/notifications/addError', {
            titleLabel: 'store.test.trainTestModel.errorNotification.title',
            error: statusResponse.message
          }, {
            root: true
          })
        } else {
          dispatch('knowledgebase/notifications/addInfo', {
            titleLabel: 'store.test.trainTestModel.successNotification.title',
            event: {
              label: 'store.test.trainTestModel.successNotification.event',
              id: 'sidebar::open',
              param: 6
            }
          }, { root: true })
        }
      } catch (error) {
        commit('SET_TRAINING_FOR_TEST', false)
        dispatch('knowledgebase/notifications/addError',
          { titleLabel: 'store.test.trainTestModel.errorNotification.title', error },
          { root: true }
        )
      }
    },

    async testMeaning ({ state, rootState, rootGetters, dispatch, commit }, { appId, q }) {
      try {
        commit('SET_PHRASE_TESTING', true)
        const computedAppId = appId !== 'all'
          ? appId
          : _get(rootGetters['knowledgebase/getCurrent'], 'endpoints.PRODUCTION.publishedAppId')

        const response = await nluApi.testMeaning({
          kbId: rootState.knowledgebase.current,
          appId: computedAppId,
          q
        })
        commit('SET_PHRASE_TESTING', false)

        return response
      } catch (error) {
        dispatch('knowledgebase/notifications/addError',
          { titleLabel: 'store.test.testMeaning.errorNotification.title', error },
          { root: true }
        )
        commit('SET_PHRASE_TESTING', false)
      }
    }
  },
  mutations: {
    SET_TRAINING_FOR_TEST (state, value) {
      state.isTrainingForTest = value
    },

    SET_PHRASE_TESTING (state, value) {
      state.phraseIsTesting = value
    }
  }
}
